module.exports = __webpack_public_path__ + "img/abouttitle.bd97163a.png";